import { render, staticRenderFns } from "./ProviderSelector.vue?vue&type=template&id=b622aae6&scoped=true&"
import script from "./ProviderSelector.vue?vue&type=script&lang=js&"
export * from "./ProviderSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b622aae6",
  null
  
)

export default component.exports